import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const InformedConsentApprover = ({ informedConsentApprover, informedConsent, handleConsentChange, shipmentFromRepo, sampleDisposal, pullLists, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.APPROVER]);

    return (
        <div className="planField">
            <GroupApprovers description={"APPROVER 2"}/>
            <FormControl required={required.includes("informedConsentApprover")}>
                <FormLabel className="planRadioTitle">
                    {sampleDisposal === "No" ? pullListLabels.informedConsent : pullListLabels.disposalRequest}
                </FormLabel>
                <RadioGroup
                    id="informedConsentApprover-field"
                    name="informedConsentApprover"
                    label={sampleDisposal === "No" ? pullListLabels.informedConsent : pullListLabels.disposalRequest}
                    value={informedConsentApprover}
                    onChange={(e) => handleConsentChange("informedConsentApprover", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit || informedConsent === 'Non-ITN'} />}
                        label="No"
                    />
                    {shipmentFromRepo === "Yes" && (
                        <FormControlLabel
                            value="Non-ITN"
                            control={<Radio disabled={!canEdit} />}
                            label="Non-ITN"
                        />
                    )}
                </RadioGroup>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"informedConsentApprover"} />
        </div>
    );
};

export default InformedConsentApprover;